export enum AppRoute {
  Landing = "/:session",
  Welcome = "/:session/welcome",
  Onboarding = "/:session/onboarding",
  VehicleCondition = "/:session/vehicle-condition",
  DamageLocation = "/:session/damage-location",
  DamagePhotos = "/:session/damage-photos",
  VehiclePhotos = "/:session/vehicle-photos",
  AdditionalDocuments = "/:session/additional-documents",
  Vin = "/:session/vin",
  ClaimSummary = "/:session/claim-summary",
  DamageReview = "/:session/damage-review",
  VehicleAnalysis = "/:session/vehicle-analysis",
  EstimateAnalysis = "/:session/estimate-analysis",
  EstimateRepariable = "/:session/estimate",
  EstimateRepariablePayee = "/:session/estimate/speedy-payment/payee-flow",
  EstimateTotalLoss = "/:session/estimate/total-loss",
  EstimateOutOfScope = "/:session/estimate/out-of-scope",
  SpeedyPayment = "/:session/estimate/speedy-payment",
  PayeeSpeedyPayment = "/:session/estimate/speedy-payment/payee-offer",
  PaymentAccepted = "/:session/estimate/speedy-payment/payment-accepted",
  PayeeAcceptance = "/:session/estimate/speedy-payment/payee-questions",
  PayeeDetails = "/:session/estimate/speedy-payment/payee-details",
  NegotiateOffer = "/:session/estimate/speedy-payment/negotiate-offer",
  TalkToClaimHandler = "/:session/estimate/speedy-payment/talk-to-claim-handler",
  FlowCompleted = "/:session/completed",
  ExternalRedirect = "/:session/external-redirect",
  WrongDevice = "/error/wrong-device",
  InvalidSession = "/error/invalid-session",
  ExpiredSession = "/error/expired-session",
  BrowserNotSupported = "/error/browser-not-supported",
  ApiError = "/error/api-error",
  CatchAll = "*",
}
